import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'
export * from '@/utils/color-utils'
export * from '@/utils/date-utils'
export * from '@/utils/file-types'
export * from '@/utils/string-utils'

export function groupBy<T>(array: T[], predicate: (value: T, index: number, array: T[]) => string) {
  return array.reduce(
    (acc, value, index, array) => {
      ;(acc[predicate(value, index, array)] ||= []).push(value)
      return acc
    },
    {} as { [key: string]: T[] },
  )
}

/**
 * Combines multiple class names into a single string.
 *
 * This function takes multiple class names as arguments, processes them, and returns a single
 * combined string of class names. It leverages the `clsx` library to handle conditional
 * class names and `twMerge` to merge Tailwind CSS class names efficiently.
 *
 * @param classes - A list of class values which can be strings, objects, arrays, etc.
 * @returns A string of combined class names.
 */
export function cn(...classes: ClassValue[]): string {
  return twMerge(clsx(...classes))
}

/**
 * Creates a DOMString containing a URL representing the given `Blob` or `MediaSource` object.
 * This URL can then be used to display the content (e.g., in an `<img>` or `<video>` tag).
 *
 * @param data The Blob or MediaSource object for which to create an object URL.
 * @returns A DOMString containing an object URL that can be used to reference the contents of the specified `Blob` or `MediaSource` object.
 */
export const createBlobUrl = (data: Blob | MediaSource) => {
  return window.URL.createObjectURL(data)
}
